import { Component } from '@angular/core';
import { ControlContainer, FormGroupDirective } from '@angular/forms';
import { GiftCardPurchaseFormService } from '../gift-card-purchase-form/gift-card-purchase-form.service';

@Component({
    selector: 'ols-gift-card-message',
    templateUrl: './message.component.html',
    styleUrls: ['./message.component.scss'],
    viewProviders: [
        { provide: ControlContainer, useExisting: FormGroupDirective },
    ],
})
export class MessageComponent {
    constructor(private formService: GiftCardPurchaseFormService) {}

    submitForm() {
        this.formService.submitForm();
    }
}
